import PropTypes from 'prop-types';
import SpinnerButton from '../shared/SpinnerButton';

const spinnerHTMLContent = '<span><div class="gh-spinner"></div></span>';

export default function UpdateCardLoadingState({
    message = 'Initializing...',
    title = 'Update your card details.',
}) {
    return (
        <>
            <h1 className="modal-title adblocker-title">{title}</h1>
            <div className="adblocker-warning">
                <p>{message}</p>
            </div>
            <SpinnerButton
                className="gh-btn gh-btn-black gh-btn-block spinner"
                html={spinnerHTMLContent}
                disabled={true}
            />
        </>
    );
}

UpdateCardLoadingState.propTypes = {
    message: PropTypes.string,
    title: PropTypes.string,
};
